// No aliased imports here: this module is also loaded from next.config.ts,
// where tsconfig `paths` are not applied.

/**
 * Host (no protocol, no port) for a shop's brand domain:
 *  - live:        www.petsdeli.<topLevelDomain>
 *  - dev/staging: <branch>[-staging].petsdeli.<topLevelDomain>
 */
export const buildShopDomain = (topLevelDomain: string): string => {
  if (process.env.IS_LIVE === 'true') {
    return `www.petsdeli.${topLevelDomain}`;
  }

  const branchName = process.env.BRANCH_NAME ?? '';
  const isStaging = process.env.PD_ENV === 'staging' && branchName !== 'dev';

  return `${branchName}${isStaging ? '-staging' : ''}.petsdeli.${topLevelDomain}`;
};
